export function getQtrAndFY() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    //Months are 0-indexed
    const currentMonth = currentDate.getMonth() + 1;

    let fiscalYear, quarter;

    //Calculate FY
    if (currentMonth >= 11) {
        fiscalYear = currentYear + 1;
    }
    else {
        fiscalYear = currentYear;
    }

    //Calculate quarter
    if (currentMonth >= 8 && currentMonth <= 10)
        quarter = "Q4";
    else if (currentMonth >= 11 || currentMonth === 1)
        quarter = "Q1";
    else if (currentMonth >= 2 && currentMonth <= 4)
        quarter = "Q2";
    else if (currentMonth >= 5 && currentMonth <= 7)
        quarter = "Q3";

    return {
        fiscalYear: fiscalYear,
        quarter: quarter
    }
}

//get the quarter start date for a given date (may be in the past)
function getQuarterStart(date) {
    const month = date.getMonth();
    const year = date.getFullYear();
    if (month >= 10 || month === 0) { // Q1: Nov, Dec, Jan
        return month === 0 ? new Date(year - 1, 10, 1) : new Date(year, 10, 1);
    }
    else if (month >= 1 && month <= 3) { // Q2: Feb, Mar, Apr
        return new Date(year, 1, 1);
    }
    else if (month >= 4 && month <= 6) { // Q3: May, Jun, Jul
        return new Date(year, 4, 1);
    }
    return new Date(year, 7, 1); // Q4: Aug, Sep, Oct
}

function getNextDay(date) {
    const nextDay = new Date(date);
    nextDay.setDate(date.getDate() + 1);
    return nextDay;
}

//get the next upcoming deadline on or after the given date
function getNextDeadline(date) {
    const quarterStart = getQuarterStart(date);
    if (date <= quarterStart) {
        return quarterStart;
    }

    //quarter start has passed, get next quarter
    const month = quarterStart.getMonth();
    const year = quarterStart.getFullYear();
    if (month === 10) return new Date(year + 1, 1, 1); // Nov -> Feb
    if (month === 7) return new Date(year, 10, 1);     // Aug -> Nov
    if (month === 4) return new Date(year, 7, 1);      // May -> Aug
    return new Date(year, 4, 1);                        // Feb -> May
}

//calculate next warning deadline based on review timing
function calculateNextWarningDeadline(lastReviewed, upcomingDeadlineAtReview, warningStartAtReview) {

    //reviewed during warning period
    if (lastReviewed >= warningStartAtReview && lastReviewed < upcomingDeadlineAtReview) {
        return getNextDeadline(getNextDay(upcomingDeadlineAtReview));
    }

    //reviewed on or after the deadline
    if (lastReviewed >= upcomingDeadlineAtReview) {

        //reviewed in same month as deadline
        if (lastReviewed.getFullYear() === upcomingDeadlineAtReview.getFullYear() &&
            lastReviewed.getMonth() === upcomingDeadlineAtReview.getMonth()) {
            return getNextDeadline(getNextDay(upcomingDeadlineAtReview));
        }

        //reviewed in month 2 or 3 of the quarter
        const nextDeadlineAfterReview = getNextDeadline(getNextDay(upcomingDeadlineAtReview));
        const nextWarningStart = new Date(nextDeadlineAfterReview);
        nextWarningStart.setDate(nextDeadlineAfterReview.getDate() - 14);

        if (lastReviewed < nextWarningStart) {
            return getNextDeadline(getNextDay(nextDeadlineAfterReview)); //skip next deadline
        }
        return nextDeadlineAfterReview;
    }

    //reviewed before warning period
    const previousDeadline = getQuarterStart(lastReviewed);
    const reviewedAfterPrevDeadline = lastReviewed > previousDeadline;
    const reviewedInPrevDeadlineMonth = (lastReviewed.getFullYear() === previousDeadline.getFullYear() &&
        lastReviewed.getMonth() === previousDeadline.getMonth()) &&
        lastReviewed >= previousDeadline;

    if (reviewedAfterPrevDeadline && !reviewedInPrevDeadlineMonth) {
        return getNextDeadline(getNextDay(upcomingDeadlineAtReview)); //skip upcoming deadline
    }
    return upcomingDeadlineAtReview;
}

//determine if project should be marked for review based on last reviewed date and current date
export function markForReview(lastReviewedDate) {

    //if no last reviewed date, always mark for review
    if (!lastReviewedDate) {
        return true;
    }

    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);

    const lastReviewed = new Date(lastReviewedDate);
    lastReviewed.setHours(0, 0, 0, 0);

    //find the next upcoming deadline from today
    const currentUpcomingDeadline = getNextDeadline(currentDate);

    //determine which deadline should trigger the next warning
    const upcomingDeadlineAtReview = getNextDeadline(lastReviewed);
    const warningStartAtReview = new Date(upcomingDeadlineAtReview);
    warningStartAtReview.setDate(upcomingDeadlineAtReview.getDate() - 14);
    const nextWarningDeadline = calculateNextWarningDeadline(
        lastReviewed,
        upcomingDeadlineAtReview,
        warningStartAtReview
    );

    //deadline has passed
    if (currentDate > nextWarningDeadline) {
        return true;
    }

    //current upcoming deadline is after scheduled warning deadline
    if (currentUpcomingDeadline > nextWarningDeadline) {
        return true;
    }

    //check if in warning period
    const nextWarningStart = new Date(nextWarningDeadline);
    nextWarningStart.setDate(nextWarningDeadline.getDate() - 14);
    return currentDate >= nextWarningStart;
}